"use client";

import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { Card } from "@/components/card";

type AnalysisCardProps = Omit<ComponentProps<typeof Card>, "id"> & {
  id?: string;
};

export const AnalysisCard = ({ id, ...props }: AnalysisCardProps) => {
  return (
    <Card
      {...props}
      className={twMerge(props.className)}
      roundedClass="rounded-none sm:rounded-md"
      id={id}
      data-testid={id}
    >
      {props.children}
    </Card>
  );
};
